export const sensorList = [
    {
        key: 'temp1',
        label: 'temp1',
        value: 0
    },
    {
        key: 'temp2',
        label: 'temp2',
        value: 1
    },
    {
        key: 'temp3',
        label: 'temp3',
        value: 2
    },
    {
        key: 'temp4',
        label: 'temp4',
        value: 3
    },
    {
        key: 'temp5',
        label: 'temp5',
        value: 4
    },
    {
        key: 'temp6',
        label: 'temp6',
        value: 5
    }
]

export const humiditySensors = [
    {
        key: 'humidity1',
        label: 'humidity1',
        value: 12
    }
]